// ** MUI Imports
import { useEffect, useState } from "react";
import { createGenericContext } from "../utils/createGenericContext";
import MeDataService from "../services/MeService";
import { useLocation } from "react-router-dom";
import { LoadingSpinner } from "../components/loading";

export interface IAuthContext {
  isLoggedIn: boolean;
}

const [useAuth, AuthContextProvider] = createGenericContext<IAuthContext>();

const AuthProvider = (props: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.indexOf("/login") === 0 ||
      location.pathname.indexOf("/privacy-policy") === 0 ||
      location.pathname.indexOf("/terms-and-conditions") === 0
    ) {
      setLoading(false)
      return;
    }
    else {
      setLoading(true)
    }

    MeDataService.me()
      .then((s) => {
        setIsLoggedIn(true);
        setLoading(false);
      })
      .catch(() => {
        setIsLoggedIn(false);
        setLoading(false);
        console.log("GO HOME")
        window.location.href = "/login";
      });
  }, [location.pathname]);

  let contextValue = {
    isLoggedIn,
  };

  return (
    <AuthContextProvider value={contextValue}>
      {loading && <div style={{margin: "50% auto", textAlign:"center"}}><LoadingSpinner /></div>}
      {!loading && <>{props.children}</>}
    </AuthContextProvider>
  );
};

export { AuthProvider, useAuth };
